import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // ── Public ──────────────────────────────────────────────────────────────
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent),
    canActivate: [guestGuard],
  },
  {
    path: 'register',
    loadComponent: () => import('./components/register/register.component').then(m => m.RegisterComponent),
    canActivate: [guestGuard],
  },

  // ── Protected partner portal ─────────────────────────────────────────────
  {
    path: '',
    loadComponent: () => import('./components/shell/shell.component').then(m => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'referrals',
        loadComponent: () => import('./components/referrals/referrals.component').then(m => m.ReferralsComponent),
      },
      {
        path: 'referrals/new',
        loadComponent: () => import('./components/referral-form/referral-form.component').then(m => m.ReferralFormComponent),
      },
      {
        path: 'referrals/:id/edit',
        loadComponent: () => import('./components/referral-form/referral-form.component').then(m => m.ReferralFormComponent),
      },
      {
        path: 'payments',
        loadComponent: () => import('./components/payments/payments.component').then(m => m.PaymentsComponent),
      },
      {
        path: 'payments/:id',
        loadComponent: () => import('./components/payment-detail/payment-detail.component').then(m => m.PaymentDetailComponent),
      },
      {
        path: 'leads',
        loadComponent: () => import('./components/lead-queue/lead-queue.component').then(m => m.LeadQueueComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'devices',
        loadComponent: () => import('./components/devices/devices.component').then(m => m.DevicesComponent),
      },

      // ── Admin sub-section ──────────────────────────────────────────────
      {
        path: 'admin/partners',
        loadComponent: () => import('./components/admin/partners-list/partners-list.component').then(m => m.PartnersListComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/partners/:id',
        loadComponent: () => import('./components/admin/partner-detail/partner-detail.component').then(m => m.PartnerDetailComponent),
        canActivate: [adminGuard],
      },
    ],
  },

  { path: '**', redirectTo: 'dashboard' },
];
